import { CSSProperties } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { Css } from "~generated/css";

type DraggableImageWrapperProps = {
  draggable: boolean;
  children: React.ReactNode;
  initialScale?: number;
  contentStyle?: CSSProperties;
};

/**
 * A draggable image wrapper component that displays an image at full size
 * and allows users to pan around to view different parts.
 * Uses react-zoom-pan-pinch for smooth pan/zoom interactions on mobile.
 */
export function DraggableImageWrapper(props: DraggableImageWrapperProps) {
  const { draggable, children, initialScale = 1, contentStyle = Css.w100.h100.$ } = props;

  if (!draggable) {
    return <>{children}</>;
  }

  return (
    <TransformWrapper initialScale={initialScale} centerOnInit doubleClick={{ mode: "toggle" }}>
      <TransformComponent wrapperStyle={Css.w100.h100.$} contentStyle={contentStyle}>
        {children}
      </TransformComponent>
    </TransformWrapper>
  );
}
